"use client";

import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";

type FAQItem = { question: string; answer: string };

export default function FAQSection({
  items,
  title = "Frequently asked questions",
}: {
  items: FAQItem[];
  title?: string;
}) {
  return (
    <section
      aria-labelledby="faq-heading"
      className="bg-white py-16 sm:py-20"
    >
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <h2
          id="faq-heading"
          className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl"
        >
          {title}
        </h2>
        <dl className="mt-8 space-y-6 divide-y divide-gray-900/10">
          {items.map((item) => (
            <Disclosure as="div" key={item.question} className="pt-6">
              {({ open }) => (
                <>
                  <dt>
                    <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                      <span className="text-base font-semibold leading-7">
                        {item.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        {open ? (
                          <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                        ) : (
                          <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2 pr-12">
                    <p className="text-base leading-7 text-gray-600">
                      {item.answer}
                    </p>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
      </div>
    </section>
  );
}
